export const checkUrl = (url) => {
	if (!url) {
		return { color: 'gray' };
	}
	return { color: 'black' };
};
